// Hero section on the Home page: big headline, short intro, and the main "Use the Tool" button.

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import StatPills from "./StatPills";
import logo from "../../assets/images/NAERLS-Logo.png";
import heroImage from "../../assets/images/Farm-Land.png";
import { homeStats } from "../../mock/homeData";

function HeroSection() {
  const { t } = useTranslation();

  return (
      <section className="homeHero u-fullBleed">
        <div className="homeHero__inner">
          <div>
            {/* Milestone badge */}
            <div className="homeHero__badge">
              <span className="homeHero__badgeDot" aria-hidden="true" />
              {t("home.hero.badge")}
            </div>

            {/* Main headline */}
            <h1 className="homeHero__title">{t("home.hero.title")}</h1>

            {/* Supporting summary */}
            <p className="homeHero__lead">{t("home.hero.lead")}</p>

            {/* Primary call-to-action */}
            <div className="homeHero__actions">
              <Link to="/map" className="homeButton homeButton--primary">
                {t("home.hero.ctaUseTool")}
              </Link>
            </div>

            {/* Credibility / context stats */}
            <StatPills
              stats={homeStats.map((s) => ({
                label: t(s.labelKey),
                value: s.value,
              }))}
            />
          </div>

          {/* Hero side card with a highlight message + image */}
          <aside className="homeHero__card" aria-label={t("home.highlight.ariaLabel")}>
            <h3 className="homeHero__cardTitle">{t("home.highlight.title")}</h3>
            <p className="homeHero__cardText">{t("home.highlight.text")}</p>
            <div className="homeHero__imageWrap" aria-hidden="true">
              <img className="homeHero__image" src={heroImage} alt="" />
            </div>
            <div className="homeHero__logoRow" aria-label={t("home.highlight.hostAriaLabel")}>
              <img src={logo} alt={t("home.highlight.logoAlt")} className="homeHero__logo" />
              <div className="homeHero__logoText">{t("home.highlight.host")}</div>
            </div>
          </aside>
        </div>
      </section>
  );
}

export default HeroSection;
